import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { UserProfile } from '../models/user-profile';
import { UrlBuilderService } from '../../common/services/url-builder.service';
import { SetUserProfileModel } from '../models/set-user-profile.model';

@Injectable()
export class UserProfilesHttpService {

  constructor(
    private http: HttpClient,
    private urlBuilder: UrlBuilderService
  ) { }
  

  getAllUserProfiles(): Observable<UserProfile[]> {
    const usersUrl = this.urlBuilder.getUrl('userprofiles');
    return this
      .http
      .get<UserProfile[]>(usersUrl)
      .pipe();
  }

  setUserProfiles(setUserProfileModel: SetUserProfileModel): Observable<object> {
    const usersUrl = this.urlBuilder.getUrl('userprofiles');
    return this
      .http
      .post(usersUrl, setUserProfileModel)
      .pipe();
  }
}
